export var occurrences = function (source, subString, allowOverlapping) {
    if (source === void 0) { source = ''; }
    if (subString === void 0) { subString = ''; }
    if (allowOverlapping === void 0) { allowOverlapping = true; }
    if (!subString) {
        return (source.length + 1);
    }
    var matches = 0;
    var position = 0;
    var step = allowOverlapping ? 1 : subString.length;
    while (true) {
        position = source.toLowerCase().indexOf(subString.toLowerCase(), position);
        if (position >= 0) {
            ++matches;
            position += step;
        }
        else {
            break;
        }
    }
    return matches;
};
